module.exports = __webpack_public_path__ + "static/media/golden_bird.9adca45.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/golden_bird.m4a
// module id = luhe
// module chunks = 1